"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _miniCalendar = _interopRequireDefault(require("../_mini-calendar"));

var _dateString = require("./../_utils/date-string");

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This component provides a nice way for a user to input a date range. The UI
 * is a month calendar that allows the user to either select a day in the
 * current month or to browse other months. If the "name" prop is provided two
 * normal html inputs are rendered under the hood (one for the start date and
 * one for the end date) so this component can be used like any other form
 * control.
 */
var DateRangeInputCalendar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateRangeInputCalendar, _React$Component);

  var _super = _createSuper(DateRangeInputCalendar);

  function DateRangeInputCalendar() {
    var _this;

    (0, _classCallCheck2["default"])(this, DateRangeInputCalendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hoverDate: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickDate", function (inputValue) {
      return _this.props.onChange(DateRangeInputCalendar.getNextValue({
        value: _this.props.value,
        input: _this.props.input,
        inputValue: inputValue,
        allowSameStartAndEnd: _this.props.allowSameStartAndEnd
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterDate", function (hoverDate) {
      return _this.setState({
        hoverDate: hoverDate
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rangeDates", function (date) {
      var _this$props = _this.props,
          value = _this$props.value,
          input = _this$props.input;
      var hoverDate = _this.state.hoverDate; // If both values are selected, highlight the range between them

      return value[0] && value[1] ? (0, _dateString.isWithinRange)(date, value[0], value[1]) : // If only the start value is selected, highlight the range between it
      // and the hover date
      hoverDate && input === "end" && value[0] && (0, _dateString.isBefore)(value[0], hoverDate) ? (0, _dateString.isWithinRange)(date, value[0], hoverDate) : // If only the end value is selected, highlight the range between it
      // and then hover date
      hoverDate && input === "start" && value[1] && (0, _dateString.isBefore)(hoverDate, value[1]) ? (0, _dateString.isWithinRange)(date, hoverDate, value[1]) : false;
    });
    return _this;
  }

  (0, _createClass2["default"])(DateRangeInputCalendar, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_miniCalendar["default"], {
        selectedDates: function selectedDates(date) {
          return date === props.value[0] || date === props.value[1];
        },
        rangeDates: this.rangeDates,
        onClickDate: this.onClickDate,
        onMouseEnterDate: this.onMouseEnterDate,
        viewDate: props.viewDate,
        onChangeViewDate: props.onChangeViewDate,
        now: props.now,
        disabledDates: props.disabledDates,
        locale: props.locale,
        monthsInView: props.monthsInView,
        monthWidth: props.monthWidth,
        previousMonthLabel: props.previousMonthLabel,
        nextMonthLabel: props.nextMonthLabel,
        renderDate: props.renderDate,
        renderDay: props.renderDay,
        dateLabel: props.dateLabel,
        animateMonthChange: props.animateMonthChange
      }, props.name ? /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        name: "".concat(props.name, "[]"),
        value: props.value[0] || ""
      }), /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        name: "".concat(props.name, "[]"),
        value: props.value[1] || ""
      })) : null);
    }
  }]);
  return DateRangeInputCalendar;
}(_react["default"].Component);

(0, _defineProperty2["default"])(DateRangeInputCalendar, "defaultProps", {
  value: []
});
(0, _defineProperty2["default"])(DateRangeInputCalendar, "getNextValue", function (_ref) {
  var value = _ref.value,
      input = _ref.input,
      inputValue = _ref.inputValue,
      allowSameStartAndEnd = _ref.allowSameStartAndEnd;

  // If we're changing the start date then update that and either return the
  // same end date if it's still valid or clear the end date if it's no longer
  // valid
  if (input === "start") {
    return [inputValue, !inputValue || !value[1] || (0, _dateString.isBefore)(inputValue, value[1]) || allowSameStartAndEnd && inputValue === value[1] ? value[1] : undefined];
  } // If we're changing the end date then update that and either return the
  // same start date if it's still valid or clear the start date if it's no
  // longer valid
  else if (input === "end") {
    return [!inputValue || !value[0] || (0, _dateString.isBefore)(value[0], inputValue) || allowSameStartAndEnd && inputValue === value[0] ? value[0] : undefined, inputValue];
  }
});
DateRangeInputCalendar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Identify whether the user will input the start or end of the date range
   * when they interact with the calendar.
   */
  input: _propTypes["default"].oneOf(["start", "end"]).isRequired,

  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD.
   */
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * A function that will be called when the value of the date input is
   * changed by the user. The new date range will be passed to the function as
   * an array of two date strings in the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * A function that will be called whenever the calendar wants to update the
   * view date itself.
   */
  onChangeViewDate: _propTypes["default"].func.isRequired,

  /**
   * If set to true the user will be able to choose the same date for the start
   * and the end of the date range.
   *
   * This can be helpful if a single date or a date range is acceptable, or if
   * the date range picker is used in conjunction with time pickers (not yet
   * part of Meridian, [+1 the backlog SIM](https://sim.amazon.com/issues/MRDN-438))
   * to allow the selection of a time range that may fall within a single day or
   * span multiple days.
   */
  allowSameStartAndEnd: _propTypes["default"].bool,

  /**
   * Determines whether changing months is animated with a sliding motion.
   */
  animateMonthChange: _propTypes["default"].bool,

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   *
   * @since 5.20.0
   */
  dateLabel: _propTypes["default"].func,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * The locale to use when rendering the input (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following properties.
   *
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "21")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   */
  renderDate: _propTypes["default"].func,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `renderDate` instead.
   *
   * @deprecated 5.20.0
   */
  renderDay: _propTypes["default"].func,

  /**
   * The value of the input as an array of two date strings in the format
   * YYYY-MM-DD.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].arrayOf(_propTypes["default"].string)
} : {};
var _default = DateRangeInputCalendar;
exports["default"] = _default;